import { createFileRoute } from '@tanstack/react-router';

import { FEATURE_FLAGS } from 'shared/consts';
import { routes } from 'shared/routes';
import { requireFeatureFlag } from 'shared/utils';

// No chrome of its own: the sections render in `_shell`, and an unknown section (`/account/foo`) shows
// the 404 page here, without the sidebar.
export const Route = createFileRoute('/_authenticated/account')({
  beforeLoad: ({ context }) =>
    requireFeatureFlag(FEATURE_FLAGS.ACCOUNT_SETTINGS_ALLOWED, context.authUser.featureAllowance, {
      fallbackRoute: routes.locations()
    })
});
